// extracted by mini-css-extract-plugin
module.exports = {"root":"Quote_root__m0t06","text":"Quote_text__xKRPr","author":"Quote_author__3Xz9t"};